import { LoadMiniChartUsecase, LoadMiniChartUsecaseImp } from 'domain/usecases/load-mini-chart-usecase';
import { makeLoadMiniChartHttpRepository } from '../repositories/http/asset-chart-http-repository-factory';

export const makeLoadMiniChartUsecase = (): LoadMiniChartUsecase => {
  return new LoadMiniChartUsecaseImp(makeLoadMiniChartHttpRepository());
};
